import {
  UserTierTypes,
  formatNumber,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';

import {Text, View} from 'native-base';

import React from 'react';
import {useTheme} from 'styled-components/native';

export interface NextTierCreditsProps {
  currentLevel: UserTierTypes;
  remainingCreditForNextLevel: number;
  nextTier?: string;
  isGiftedTier: boolean;
  byInvitation?: boolean;
  hideLabel?: boolean;
  invitationRequired?: boolean;
}

const NextTierCredits: React.FC<NextTierCreditsProps> = props => {
  const {
    currentLevel,
    remainingCreditForNextLevel,
    nextTier,
    byInvitation = false,
    hideLabel = false,
    invitationRequired = false,
  } = props;

  const theme = useTheme();
  const {white, shuttleGray} = theme.colors;
  const isDesktop = useIsDesktop();
  const onDark = isDesktop && currentLevel === UserTierTypes.SEVEN_STARS;
  const color = onDark ? white : shuttleGray;
  const fontSize = isDesktop ? '14px' : '11px';

  if (hideLabel) {
    return null;
  }

  if (invitationRequired) {
    return (
      <Text
        fontFamily="body"
        fontSize={fontSize}
        color={color}
        textAlign={isDesktop ? 'center' : undefined}>
        Invitation Required
      </Text>
    );
  }

  return (
    <View flexDirection="row">
      <Text
        fontFamily="body"
        fontSize={fontSize}
        fontWeight="bold"
        color={color}>
        {formatNumber(remainingCreditForNextLevel)}{' '}
      </Text>
      <Text fontFamily="body" fontSize={fontSize} color={color}>
        to {nextTier}
        {byInvitation ? ' + Invitation' : ''}
      </Text>
    </View>
  );
};

export default NextTierCredits;
